import '../../App.css';
import React, { useContext, useState } from "react";
import { Form, Row, Col, Tab, Tabs, InputGroup } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';
import InputMask from 'react-input-mask';

function ModalCadastrarFornecedor({ closeModal, currentPage }) {
    const { CadastrarFornecedor, CadastroFornecedor, setCadastroFornecedor } = useContext(ServicoContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [tipoDocumento, setTipoDocumento] = useState(0)

    const handleChange = (event) => {
        setCadastroFornecedor({ ...CadastroFornecedor, [event.target.name]: event.target.value })
    }

    const handleClose = () => {
        setCadastroFornecedor({ razaoSocial: "", fantasia: "", tipoDocumento: 0, documento: "", telefone: "", email: "", site: "", cep: "", uf: "", cidade: "", endereco: "", numero: "", bairro: "", complemento: "" });
        closeModal(false);
    };

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar fornecedor</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={(e) => CadastrarFornecedor(e, currentPage)}>
                    <div className="modal-content">
                        <Tabs fill className='mt-3 mb-3'>
                            <Tab eventKey="info" title={<span>Informações gerais</span>}>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Razão social</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="razaoSocial" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome fantasia</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="fantasia" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo do Documento</Form.Label>
                                            <Form.Select aria-label="Default select example" onChange={(e) => setTipoDocumento(e.target.value)} name="tipoDocumento">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>CPF</option>
                                                <option value={2}>CNPJ</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Documento identificação</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    as={InputMask}
                                                    mask={tipoDocumento == 1 ? '999.999.999-99' : '99.999.999/9999-99'} 
                                                    maxLength={255} onChange={handleChange} name="documento"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Telefone</Form.Label>
                                            <Form.Control as={InputMask} mask="(99) 99999-9999" maxLength={255} onChange={handleChange} name="telefone" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>E-mail</Form.Label>
                                            <Form.Control type='email' maxLength={255} onChange={handleChange} name="email" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Site</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="site" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="endereco" title={<span>Endereço</span>}>
                                <Row>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>CEP</Form.Label>
                                            <Form.Control as={InputMask} mask="99999-999"  maxLength={255} onChange={handleChange} name="cep" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>UF</Form.Label>
                                            <Form.Control as={InputMask} mask="aa" maxLength={255} onChange={handleChange} name="uf" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cidade</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="cidade" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Endereço</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="endereco" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Número</Form.Label>
                                            <Form.Control type='number' maxLength={255} onChange={handleChange} name="numero" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bairro</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="bairro" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Complemento</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="complemento" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={handleClose}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCadastrarFornecedor